import { useQuery } from '@tanstack/react-query'

import { useSurveyQueryFn } from './useSurveyQueryFn'
import { useSurveyQueryKey } from './useSurveyQueryKey'

export const useSurveyQuery = () => {
  const queryFn = useSurveyQueryFn()
  const queryKey = useSurveyQueryKey()

  return useQuery({ queryFn, queryKey })
}
